/**
 * Prototyper Types
 *
 * Types for prototype creation and management
 */

/**
 * LLM used only for POST /prototype generation (not conversation llm_family).
 */
export interface PrototyperGenerationModel {
  label: string;
  modelProvider: string;
  modelChoice: string;
}

export const PROTOTYPER_GENERATION_MODELS: readonly PrototyperGenerationModel[] = [
  // { label: 'GLM 5', modelProvider: 'zai', modelChoice: 'glm-5' },
  { label: 'Gemini 3 Flash', modelProvider: 'Google', modelChoice: 'gemini-3-flash-preview' },
  { label: 'Mimo V2 Pro', modelProvider: 'xiaomi', modelChoice: 'mimo-v2-pro' },
  // { label: 'Kimi K2.5 Thinking', modelProvider: 'moonshotai', modelChoice: 'kimi-k2.5' },
] as const;

export const DEFAULT_PROTOTYPER_GENERATION_MODEL: PrototyperGenerationModel =
  PROTOTYPER_GENERATION_MODELS[0];

/**
 * Parameters for creating a prototype
 */
export interface PrototypeCreationParams {
  conversationId: string;
  projectId?: string | null;
  modelProvider: string;
  modelChoice: string;
  signal?: AbortSignal;
}

/**
 * Response from prototype creation API
 */
export interface PrototypeCreationResponse {
  prototype_id?: string;
  prototype_url?: string;
  demo_url?: string;
  demoUrl?: string;
  prototyper_demo_link_id?: number;
  isNewlyGenerated?: boolean;
  id?: number;
  slug?: string | null;
  header?: string | null;
  conversationId?: string;
  projectId?: string;
  status: 'success' | 'error';
  message?: string;
  data?: any;
}

/**
 * Prototyper state
 */
export interface PrototyperState {
  isCreatingPrototype: boolean;
  prototypeError: string | null;
  prototypeUrl: string | null;
  isNewlyGenerated?: boolean;
}

/**
 * Parameters for updating a prototyper demo link
 */
export interface UpdatePrototyperDemoLinkParams {
  id: number;
  slug?: string | null;
}

/**
 * Response from fetching prototyper by slug
 */
export interface PrototyperBySlugResponse {
  id: string;
  llmInteractionId: string;
  tmpLlmInteractionId: string;
  demoUrl: string;
  createdAt: string;
  slug: string;
  header: string;
}
